import { useNavigate } from 'react-router-dom';
import css from './ExportPdfButton.module.css';

export function ExportPdfButton() {
  const navigate = useNavigate();

  const handlePreview = () => {
    navigate('/print-preview');
  };

  return (
    <button
      type="button"
      className={css.button}
      onClick={handlePreview}
      aria-label="Open print preview"
      title="Open print preview"
      data-print-hidden="true"
    >
      Print preview
    </button>
  );
}
